import { createRootRoute, Outlet } from "@tanstack/react-router";
import { AppError } from "~/components/app-loader";

function RootErrorComponent({ error }: { error: unknown }) {
  const status =
    typeof error === "object" && error !== null && "status" in error ? (error as { status: number }).status : 500;
  return <AppError status={status} onRetry={() => window.location.assign("/")} retryLabel="Back to port" />;
}

export const Route = createRootRoute({
  component: () => <Outlet />,
  errorComponent: RootErrorComponent,
  notFoundComponent: () => <AppError status={404} onRetry={() => window.history.back()} />,
});
